import { qualifyUrls } from "routing/Routes";
const SecurityRoutes = {
  TEAMS: {
    OVERVIEW: "/system/teams",
    CREATE: "/system/teams/new",
    DETAILS: (id) => `/system/teams/${id}`,
    EDIT: (id) => `/system/teams/${id}/edit`
  }
};
const routes = qualifyUrls(SecurityRoutes);
export default {
  ...routes,
  unqualified: SecurityRoutes
};
